<template>
	<div
		role="button"
		v-on:click="openCarousel($event)"
		class="c-gallery__thumb"
		v-bind:class="{ 'o-button--loading': this.loading }"
		aria-label="Open image in light-box"
	>
		<slot></slot>
	</div>
</template>

<script>
	// this is very similar to gallery-button
	// we have them separate so you can remove unwanted components painlessly
	import lightbox from "./lightbox-carousel.vue";

	export default {
		name: "v-gallery-thumbs",
		data: function () {
			return {
				loading: false,
				carouselOpen: false,
				carouselData: {
					component: lightbox,
					props: {
						index: this.galleryIndex,
						items: this.items,
						id: this.galleryId,
						type: this.type,
						name: this.name,
						modalType: "opaque",
					},
				},
			};
		},
		props: {
			galleryId: {
				type: Number,
			},
			galleryIndex: {
				type: Number,
			},
			name: {
				type: String,
			},
			items: {
				type: Array,
			},
		},
		methods: {
			openCarousel(e) {
				e.preventDefault();
				this.loading = true;
				this.$store.dispatch("changeModalContent", this.carouselData);
				this.$store.dispatch("openModal");
				this.loading = false;
				this.carouselOpen = true;
			},
			setPanelGridRows(gallery) {
				const galleryItems = gallery.getElementsByClassName("c-gallery__item");

				let rowStart = 1;
				let rowEnd = 3;

				for (let i = 0; i < galleryItems.length; i++) {
					let item = galleryItems[i];
					let nextItem = galleryItems[i + 1];

					item.style.gridRowStart = rowStart;
					item.style.gridRowEnd = rowEnd;

					// increment row values for next item
					if (item.classList.contains("c-gallery__item--square")) {
						// if next item is also square, about to repeat pattern
						if (
							nextItem &&
							nextItem.classList.contains("c-gallery__item--square")
						) {
							rowStart = rowStart + 2;
							rowEnd = rowEnd + 2;
						} else {
							rowEnd = rowEnd - 1;
						}
					} else {
						// square block to follow rectangle (with exceptions)
						if ((i % 4 == 0 || i % 10 == 0) && i !== 8 && i !== 20) {
							rowStart--;
						} else {
							rowStart++;
							rowEnd++;
						}
					}
				}
			},
		},
		mounted() {
			this.galleryPanels = document.querySelectorAll(".c-gallery--panel");

			if (this.galleryPanels.length) {
				this.galleryPanels.forEach((gallery) => this.setPanelGridRows(gallery));
			}
		},
	};
</script>
